// extracted by mini-css-extract-plugin
module.exports = {"bb-accordion":"bb-accordion__YR1ri"};